import { Link } from "react-router";
import { Aviso } from "../componentes/ui";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

/**
 * GEOedu no portal do cliente (requisito 5 da Amanda, 01/10/2026).
 *
 * **Estado vazio honesto.** O protótipo não desenha uma tela própria para o GEOedu: ele aparece
 * como item do menu e como origem na busca da Ajuda, e depende de um SSO entre o portal e o
 * GEOedu para abrir o conteúdo já autenticado — e "falta confirmar se o GEOedu suporta SSO".
 * Sem isso o portal não tem o que listar nem para onde mandar o cliente, e inventar uma lista de
 * cursos ou um link sem login seria entregar uma promessa que o portal não cumpre.
 *
 * Visibilidade por usuário: `geoedu:ver` é a tela "GEOedu" da matriz de acesso; o menu esconde o
 * item e a tela repete a conferência para quem digita o endereço.
 *
 * Pendência (registrada no HANDOFF): confirmar o SSO com o GEOedu e, então, trocar este estado
 * pelas trilhas do cliente e o atalho que abre na origem.
 */
export function GeoeduDoCliente() {
  useTitulo("GEOedu");
  const sessao = useSessao();

  if (!podeNaSessao(sessao.data, "geoedu:ver")) {
    return (
      <div data-testid="geoedu-do-cliente">
        <h1 className="titulo-pagina">GEOedu</h1>
        <Aviso tom="marca" data-testid="geoedu-sem-permissao">
          <b>O seu acesso não inclui o GEOedu.</b> Quem administra o acesso da sua empresa pode
          liberá-lo.
        </Aviso>
      </div>
    );
  }

  return (
    <div data-testid="geoedu-do-cliente">
      <h1 className="titulo-pagina">GEOedu</h1>
      <p className="lead">
        Os treinamentos em vídeo e as trilhas de estudo da GEOvendas para a sua equipe.
      </p>

      <Aviso tom="marca" data-testid="geoedu-indisponivel">
        <b>O GEOedu ainda não abre por aqui.</b> Estamos conectando o portal ao GEOedu para que
        o seu acesso entre já autenticado, sem um segundo login. Assim que a ligação estiver
        pronta, as suas trilhas e aulas aparecem nesta tela.
      </Aviso>

      <p className="nota-rodape mt-4">
        Enquanto isso, o passo a passo dos módulos está na{" "}
        <Link to="/app/ajuda">Central de ajuda</Link> e as gravações dos treinamentos feitos com a
        sua consultora, em <Link to="/app/materiais">Materiais</Link>.
      </p>
    </div>
  );
}
